import React from 'react'
import propTypes from 'prop-types'
import { Typography, makeStyles } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/CheckCircle'

const useStyles = makeStyles((theme) => ({
	row: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(2),
		marginBottom: theme.spacing(3),
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(0.5)
	},
	step: {
		display: 'flex',
		alignItems: 'center',
		// Explicit gap between bullet and label — fixes the "(2)Data" run-in.
		gap: theme.spacing(1),
		whiteSpace: 'nowrap'
	},
	bullet: {
		width: 28,
		height: 28,
		borderRadius: '50%',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: 13,
		fontWeight: 600,
		flexShrink: 0
	},
	bulletPending: {
		backgroundColor: theme.palette.grey[300],
		color: theme.palette.text.secondary
	},
	bulletActive: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText
	},
	bulletDone: {
		color: theme.palette.success.main,
		fontSize: 28
	},
	separator: {
		flex: 1,
		height: 1,
		backgroundColor: theme.palette.divider,
		minWidth: 32
	},
	label: {
		fontWeight: 500
	},
	labelInactive: {
		color: theme.palette.text.secondary,
		fontWeight: 400
	}
}))

const StepIndicator = ({ currentStep }) => {
	const classes = useStyles()
	const steps = [
		{ n: 1, label: 'Type' },
		{ n: 2, label: 'Data' },
		{ n: 3, label: 'Confirm' }
	]
	return (
		<div className={classes.row}>
			{steps.map((s, i) => (
				<React.Fragment key={s.n}>
					<div className={classes.step}>
						{currentStep > s.n ? (
							<CheckIcon className={classes.bulletDone} />
						) : (
							<span className={`${classes.bullet} ${currentStep === s.n ? classes.bulletActive : classes.bulletPending}`}>
								{s.n}
							</span>
						)}
						<Typography variant='body2' className={`${classes.label} ${currentStep === s.n ? '' : classes.labelInactive}`}>
							{s.label}
						</Typography>
					</div>
					{i < steps.length - 1 && <div className={classes.separator} />}
				</React.Fragment>
			))}
		</div>
	)
}

StepIndicator.propTypes = {
	currentStep: propTypes.oneOf([1, 2, 3]).isRequired
}

export default StepIndicator
